<template>
  <div>
    <avue-crud :option="option" :data="list.value" ref="crud" @refresh-change="refreshChange">
      <!-- 自定义搜索框 -->
      <template slot="mySearch">
        <div class="search-contain">
          <Search @exportActiveCode="exportCode"></Search>
        </div>
      </template>
      <!-- 自定义表格索引列 -->
      <template #index="{ row }">
        <el-radio v-model="selectRow" :label="row.index">&nbsp;</el-radio>
      </template>
      <template #cdkeyNum="{ row }">
        <span style="color: #409EFF"><span v-if="row.generateType === 2">已生成：</span><span
            style="color: #409EFF;cursor: pointer;" @click="handleDetail(row)">{{ row.cdkeyNum }}</span></span>
      </template>
      <!-- 自定义表格列 -->
      <!-- <template #clientTypesDesc="{ row }">
        <div style="display: flex">
         
        </div>
      </template> -->
      <!-- 自定义表格操作栏 -->
      <template #menu="{ row }">
        <el-button v-auth="'ACTIVE_CODE_GENERATE_LOG'" type="text" size="small" @click="viewLog(row)">日志</el-button>
        <el-button v-auth="'ACTIVE_CODE_GENERATE_EDIT'" type="text" size="small" @click="edit(row)">编辑</el-button>
        <el-button v-auth="'ACTIVE_CODE_GENERATE_DEL'" type="text" size="small" @click="del(row)">删除</el-button>
      </template>
    </avue-crud>
    <!-- 分页组件 -->
    <ElementPagination style="margin-bottom: 20px" :current-page="searchParams.current" :page-size="searchParams.size"
      :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
    <!-- 提交审核 -->
    <AuditDialog ref="auditDialog">
      <template #submitFooter="scope">
        <div>
          <el-button type="primary" size="small" @click="submitAudit(scope)">确认提交审核</el-button>
        </div>
      </template>
      <template #auditFooter="scope">
        <div style="display: flex; flex-direction: column; align-items: center">
          <div style="display: flex; margin-bottom: 10px">
            <el-button style="width: 100px; margin-right: 10px" size="small" @click="auditPass(scope.id)">审核通过</el-button>
            <el-button style="width: 100px" type="primary" size="small" @click="auditReject(scope.id)">审核不通过</el-button>
          </div>
          <div>
            <el-input class="auditOpinion" v-model="auditOpinion" maxlength="999" size="small" clearable
              placeholder="审核意见"></el-input>
          </div>
        </div>
      </template>
    </AuditDialog>
    <!-- 操作日志 -->
    <OptionLog ref="optionLog" :columnConfig="optionLogColumn" @reload="reloadOpt" :closeBtn="false">
      <template #type="{ row }">
        <div>
          <!-- 操作类型(1-新增, 2-修改, 3-删除, 4-提交审核, 5-撤销审核, 6-审核通过, 7-审核拒绝) -->
          <span v-if="row.type === 1">新增</span>
          <span v-if="row.type === 2">修改</span>
          <span v-if="row.type === 3">删除</span>
          <span v-if="row.type === 4">提交审核</span>
          <span v-if="row.type === 5">撤销审核</span>
          <span v-if="row.type === 6">审核通过</span>
          <span v-if="row.type === 7">审核拒绝</span>
        </div>
      </template>
    </OptionLog>
    <!-- 激活码明细 -->
    <DetailDialog ref="detail"></DetailDialog>
    <!-- 新增 -->
    <AddDialog ref="add"></AddDialog>
  </div>
</template>

<script>
import Search from "./Search.vue";
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
import AuditDialog from "@/components/OptionsLog/auditDialog.vue";
import OptionLog from "@/components/OptionsLog/optionLog.vue";
import DetailDialog from "./Detail.vue"
import AddDialog from "./Add.vue";
import { deleteActiveCodeGenerate, exportActiveCode, getOperationLog } from '@/api/memberNew/activeCodeGenerate'
import moment from "moment";
import { cloneDeep } from 'lodash'
export default {
  name: "WebSaaSTable",
  inject: ["currentTab", "list", "searchParams", "getList", "getActiveGoodsList"],
  provide() {
    return {
      getActiveGoodsList: this.getActiveGoodsList,
    };
  },
  components: {
    Search,
    ElementPagination,
    AuditDialog,
    OptionLog,
    DetailDialog,
    AddDialog
  },
  /** 监听路由的query是否有参数 */
  watch: {
    $route: {
      handler: function (route) {
        if (route.query.id) {
          this.searchParams.id = route.query.id;
          this.getList();
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: true,
        // searchMenuSpan: 6,
        tree: true,
        border: true,
        /** 表格索引 */
        index: false,
        /** 表格搜索显隐按钮 */
        searchShowBtn: true,
        /** 是否启用功能按钮 */
        searchIcon: true,
        searchIndex: 0,
        /** 表格查看按钮 */
        viewBtn: false,
        /** 表格新增按钮 */
        addBtn: false,
        /** 表格删除按钮 */
        delBtn: false,
        /** 表格修改按钮 */
        editBtn: false,
        /** 导出按钮 */
        excelBtn: false,
        /** 是否有选择框	 */
        selection: false,
        /** 表格高度 */
        height: 500,
        /** 是否有操作栏 */
        menu: true,
        /** 空数据时显示的文本内容 */
        emptyText: "-",
        /** 表格搜索按钮 */
        // searchBtn: false,
        /** 表格清空按钮 */
        // emptyBtn: false,
        /** 开启拖拽功能 */
        // sortable: true,
        // dragHandler: true,
        // rowSort: true,
        // columnSort: true,
        // menuWidth: 200,
        column: [
          {
            label: " ",
            prop: 'index',
            slot: true,
            width: '60',
          },
          {
            label: "批次ID",
            width: "60",
            prop: "id",
            // slot: true,
            /** 当内容过长被隐藏时显示 tooltip */
            overHidden: false,
            // search: true,
            columnBtn: false,
            /** 搜索项位置排序，序号越大越靠前 */
            // searchOrder: 1,
          },
          {
            label: "生成方式",
            width: "120",
            prop: "generateType",
            dicData: [
              {
                label: "立即生成",
                value: 1,
              },
              {
                label: "实时生成",
                value: 2,
              }
            ]
          },
          {
            label: "激活码数量",
            width: "120",
            prop: "cdkeyNum",
            slot: true
          },
          {
            label: "已激活数量",
            width: "120",
            prop: "cdkeyActiveNum",
            overHidden: true,
          },
          {
            label: "激活码名称",
            width: "120",
            prop: "cdkeyName",
          },

          {
            label: "业务类型",
            width: "100",
            prop: "businessName",
          },
          {
            label: "过期时间",
            width: "90",
            prop: "expireTime",

            /** 当内容过长被隐藏时显示 tooltip */
            overHidden: true,
            formatter: (row, column, cellValue) => {
              return cellValue ? cellValue : "-"
            },
          },
          {
            label: "有效期天数",
            width: "90",
            prop: "validDays",
            formatter: (row, column, cellValue) => {
              return cellValue ? cellValue + "天" : "-"
            },
          },
          {
            label: "备注",

            prop: "descr",
            /** 当内容过长被隐藏时显示 tooltip */
            overHidden: true,
          },

          {
            label: "",
            prop: "my",
            hide: true,
            showColumn: false,
            search: true,
            display: false,
            menuClassName: "myClass",
            searchslot: true,
          },
        ],
      },
      /** 操作日志配置列 */
      optionLogColumn: [
        {
          prop: "operateTime",
          label: "操作时间",
        },
        {
          prop: "operator",
          label: "操作人",
        },
        {
          prop: "type",
          label: "操作类型",
          slot: "type",
        }
      ],
      /** 选择的行数据 */
      selectRow: "",
    };
  },

  methods: {
    /** 导出激活码 */
    async exportCode() {
      const id = this.selectRow
      if (id) {
        console.log("导出激活码", id);
        const res = await exportActiveCode({ id });
        const blob = new Blob([res.data]);
        console.log("导出的响应", res);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        // 设置下载文件的名称和扩展名
        a.download = decodeURIComponent(
          "激活码记录_" + moment().format("YYYY-MM-DD") + ".xlsx"
        );
        document.body.appendChild(a);
        a.click();
        // 释放URL对象
        window.URL.revokeObjectURL(url);
      } else {
        Message.error("请选择要导出的激活码批次");
      }

    },
    /** 查看激活码明细 */
    handleDetail(row) {
      console.log("查看激活码明细", row);

      this.$refs.detail.show(row.id);
    },
    //^ ^--------------操作栏内的事件-------------^ ^
    /** 删除 */
    del(row) {
      console.log("删除", row);
      this.$confirm("是否删除该激活码批次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const { data } = await deleteActiveCodeGenerate(row.id);
        console.log("删除的响应", data);
        if (data.code === 200) {
          Message.success("删除成功");
          /** 通知刷新列表 */
          this.getList();
        }
      }).catch(() => {
        console.log("取消删除");
      });
    },
    /** 编辑 */
    edit(row) {
      console.log("编辑", row);
      this.$refs.add.show(row, "edit");
    },
    /** 提交审核 */
    submitAuditShow() {
      this.$refs.auditDialog.show({
        1: {
          name: 1,
          value: 1,
        },
        2: {
          name: 2,
          value: 2,
        },
      });
      this.$refs.auditDialog.slotControl.submitFooter = true;
    },
    /** 审核 */
    auditShow() {
      this.$refs.auditDialog.show({
        1: {
          name: 1,
          value: 1,
        },
        2: {
          name: 2,
          value: 2,
        },
      });
      this.$refs.auditDialog.slotControl.auditFooter = true;
    },
    /** 查看日志 */
    async viewLog(row) {
      console.log("查看日志", row.id);
      const optSearch = this.$refs.optionLog.searchParams;
      const { data } = await getOperationLog({
        ...optSearch,
        subjectId: row.id,
      });
      console.log("查看日志的响应", data);
      const list = cloneDeep(data.data.records);
      optSearch.total = data.data.total;

      this.$refs.optionLog.show(list, row.id);

    },
    /** 日志分页 */
    async reloadOpt(id) {
      console.log("日志分页", id);
      const optSearch = this.$refs.optionLog.searchParams;
      const { data } = await getOperationLog({
        ...optSearch,
        subjectId: id,
      });
      console.log("查看日志的响应", data);
      const list = cloneDeep(data.data.records);
      this.$refs.optionLog.list = list;
      this.$refs.optionLog.searchParams.total = data.data.total;
    },
    //^ ^--------------分页相关-------------^ ^
    /** 刷新 */
    refreshChange() {
      Message.success('刷新成功')
      this.getList();
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.auditOpinion {
  ::v-deep .el-input__inner {
    text-align: center;
    width: 300px;
  }
}

::v-deep .avue-crud__pagination {
  display: none !important;
}

::v-deep .avue-form__group {
  .el-col {
    padding: 0px !important;
    margin: 0px !important;
  }
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep .avue-crud .avue-crud__search .avue-form .avue-form__group .avue-form__row .el-form-item label {
  float: none;
  display: inline-block;
  width: 100%;
}
</style>